"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuthStore } from "@shared/src/stores/useAuthStore";
import { Spinner } from "@shared/src/components/common/misc/Spinner";
import { cookieManager } from "@shared/src/lib/auth/cookieManager";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const router = useRouter();
  const { activeAccount, isInitialised } = useAuthStore();

  useEffect(() => {
    const cookie = cookieManager().getAuthToken();
    console.log("🔒 ProtectedRoute is running...", { cookie, activeAccount, isInitialised });
    // If there's no active account, redirect to home
    if ((!cookie || !activeAccount) && isInitialised) {
      router.replace("/");
    }
  }, [activeAccount, router, isInitialised]);

  // Show loading state while checking authentication
  if (!activeAccount) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner size={40} />
      </div>
    );
  }

  return <>{children}</>;
}
